import React, { useState, useEffect } from "react";
import './styles.css'
import Loader from '../../../components/loader/loader.component'
import { ToastContainer } from 'react-toastify';
import { useDispatch, useSelector } from 'react-redux'
import { useNavigate, useLocation } from 'react-router-dom';
import Select from 'react-select'
import { displayCurrencySymbolLeft, displayErrorToast, displaySuccessToast, isEmpty, isLoggedInUserBusiness, isLoggedInUserEmployee, isNull, removeSpecialCharAndChangeToPascal } from "../../../utils/Utils";
import {
    projectDetailRequest, requestProjectRequest, requestProjectRequestStatus,
    projectAssignEmployeeRequest, projectAssignEmployeeRequestStatus,
    projectRemoveEmployeeRequest, projectRemoveEmployeeRequestStatus,
    rejectEmployeeProjectRequest, rejectEmployeeProjectRequestStatus,
    updateProjectDetailRequest, updateProjectDetailRequestStatus
} from '../../../redux/project/project.action'
import ScreenLabel from "../../../components/label/screen-label/screenLabel";
import moment from "moment";
import { API_CONSTANTS, APP_CONSTANTS, ROUTES } from "../../../utils/AppConstants";
import CommonScreenContent from "../../../components/screen/common-screen-content/commonScreenContent";
import CommonFormBorder from "../../../components/common-form-border/commonFormBorder";
import FormFieldLabel from "../../../components/label/form-field-label/formFieldLabel";
import { config } from "../../../config";
import { checkFunctionalityPermission, PERMISSION_SUB_TYPE, PERMISSION_TYPE } from "../../../utils/PermissionUtil";
import ButtonRow from "../../../components/button/button-row/buttonRow";
import CommonButton from "../../../components/button/common-button/commonButton";
import CommonCheckbox from "../../../components/common-checkbox/commonCheckbox";
import CommonInputFloatFull from "../../../components/input/common-input-float-full/commonInputFloatFull";
import Modal from 'react-bootstrap/Modal';

const ProjectDetail = props => {
    const { state } = useLocation()
    const { user, employeeSelectedBusiness, employeeSelectedLocation } = useSelector(state => state.user)
    const [isLoading, setLoading] = useState(false)
    const dispatch = useDispatch()
    let navigate = useNavigate();
    const { projectDetailSuccess, projectDetailError, updateProjectDetailSuccess,
        updateProjectDetailError, updateProjectDetailReqStatus, projectAssignEmployeeSuccess,
        projectAssignEmployeeError, projectAssignEmployeeReqStatus, projectRemoveEmployeeSuccess,
        projectRemoveEmployeeError, projectRemoveEmployeeReqStatus, requestProjectSuccess,
        requestProjectError, requestProjectReqStatus, rejectEmployeeProjectRequestSuccess,
        rejectEmployeeProjectRequestError, rejectEmployeeProjectRequestReqStatus
    } = useSelector(state => state.project)
    const [isNominationOpen, setIsNominationOpen] = useState(false)
    const [description, setDescription] = useState('')
    const [name, setName] = useState('')
    const [selectedStatus, setSelectedStatus] = useState()
    const [showStatusChangeModal, setShowStatusChangeModal] = useState(false)
    const STATUS_LIST = [
        { key: APP_CONSTANTS.PROJECT_STATUS.NEW, value: removeSpecialCharAndChangeToPascal(APP_CONSTANTS.PROJECT_STATUS.NEW) },
        { key: APP_CONSTANTS.PROJECT_STATUS.IN_PROGRESS, value: removeSpecialCharAndChangeToPascal(APP_CONSTANTS.PROJECT_STATUS.IN_PROGRESS) },
        { key: APP_CONSTANTS.PROJECT_STATUS.COMPLETE, value: removeSpecialCharAndChangeToPascal(APP_CONSTANTS.PROJECT_STATUS.COMPLETE) },
        { key: APP_CONSTANTS.PROJECT_STATUS.ON_HOLD, value: removeSpecialCharAndChangeToPascal(APP_CONSTANTS.PROJECT_STATUS.ON_HOLD) },
        { key: APP_CONSTANTS.PROJECT_STATUS.PENDING, value: removeSpecialCharAndChangeToPascal(APP_CONSTANTS.PROJECT_STATUS.PENDING) },
        { key: APP_CONSTANTS.PROJECT_STATUS.CANCELLED, value: removeSpecialCharAndChangeToPascal(APP_CONSTANTS.PROJECT_STATUS.CANCELLED) },
    ]
    const [showNameEdit, setShowNameEdit] = useState(false)
    const [showDescriptionEdit, setShowDescriptionEdit] = useState(false)
    const [comment, setComment] = useState('')

    useEffect(() => {
        fetchProjectDetail()
    }, [])

    const fetchProjectDetail = () => {
        setLoading(true)
        const data = {
            projectId: state.projectId,
            params: {
                businessId: state.businessId,
                locationId: state.locationId
            }
        }
        dispatch(projectDetailRequest(data))
    }

    useEffect(() => {
        if (!isEmpty(projectDetailSuccess)) {
            setLoading(false)
            if (!isEmpty(projectDetailSuccess.data)) {
                setDescription(projectDetailSuccess.data.description)
                setName(projectDetailSuccess.data.name)
                setIsNominationOpen(projectDetailSuccess.data.isInvitationOpen)
                const status = STATUS_LIST.find(item => item.key === projectDetailSuccess.data.projectStatus)
                if (!isEmpty(status)) {
                    setSelectedStatus(status)
                }
            }
        } else if (!isEmpty(projectDetailError)) {
            setLoading(false)
        }
    }, [projectDetailSuccess, projectDetailError])

    useEffect(() => {
        if (updateProjectDetailReqStatus === API_CONSTANTS.SUCCESS_STATUS) {
            setLoading(false)
            displaySuccessToast(updateProjectDetailSuccess.data.message)
            fetchProjectDetail()
            setComment('')
        } else if (updateProjectDetailReqStatus === API_CONSTANTS.ERROR_STATUS) {
            setLoading(false)
            displayErrorToast(updateProjectDetailError.message)
        }
        if (updateProjectDetailReqStatus?.length) {
            dispatch(updateProjectDetailRequestStatus(''))
        }
    }, [updateProjectDetailSuccess, updateProjectDetailError, updateProjectDetailReqStatus])

    useEffect(() => {
        if (projectAssignEmployeeReqStatus === API_CONSTANTS.SUCCESS_STATUS) {
            setLoading(false)
            displaySuccessToast(projectAssignEmployeeSuccess.data.message)
            fetchProjectDetail()
        } else if (projectAssignEmployeeReqStatus === API_CONSTANTS.ERROR_STATUS) {
            setLoading(false)
            displayErrorToast(projectAssignEmployeeError.message)
        }
        if (projectAssignEmployeeReqStatus?.length) {
            dispatch(projectAssignEmployeeRequestStatus(''))
        }
    }, [projectAssignEmployeeSuccess, projectAssignEmployeeError, projectAssignEmployeeReqStatus])

    useEffect(() => {
        if (projectRemoveEmployeeReqStatus === API_CONSTANTS.SUCCESS_STATUS) {
            setLoading(false)
            displaySuccessToast(projectRemoveEmployeeSuccess.data.message)
            fetchProjectDetail()
        } else if (projectRemoveEmployeeReqStatus === API_CONSTANTS.ERROR_STATUS) {
            setLoading(false)
            displayErrorToast(projectRemoveEmployeeError.message)
        }
        if (projectRemoveEmployeeReqStatus?.length) {
            dispatch(projectRemoveEmployeeRequestStatus(''))
        }
    }, [projectRemoveEmployeeSuccess, projectRemoveEmployeeError, projectRemoveEmployeeReqStatus])

    useEffect(() => {
        if (requestProjectReqStatus === API_CONSTANTS.SUCCESS_STATUS) {
            setLoading(false)
            displaySuccessToast(requestProjectSuccess.data.message)
            fetchProjectDetail()
        } else if (requestProjectReqStatus === API_CONSTANTS.ERROR_STATUS) {
            setLoading(false)
            displayErrorToast(requestProjectError.message)
        }
        if (requestProjectReqStatus?.length) {
            dispatch(requestProjectRequestStatus(''))
        }
    }, [requestProjectSuccess, requestProjectError, requestProjectReqStatus])

    useEffect(() => {
        if (rejectEmployeeProjectRequestReqStatus === API_CONSTANTS.SUCCESS_STATUS) {
            setLoading(false)
            displaySuccessToast(rejectEmployeeProjectRequestSuccess.data.message)
            fetchProjectDetail()
        } else if (rejectEmployeeProjectRequestReqStatus === API_CONSTANTS.ERROR_STATUS) {
            setLoading(false)
            displayErrorToast(rejectEmployeeProjectRequestError.message)
        }
        if (rejectEmployeeProjectRequestReqStatus?.length) {
            dispatch(rejectEmployeeProjectRequestStatus(''))
        }
    }, [rejectEmployeeProjectRequestSuccess, rejectEmployeeProjectRequestError, rejectEmployeeProjectRequestReqStatus])

    const getStatusClassname = (status) => {
        if (status === APP_CONSTANTS.PROJECT_STATUS.NEW) {
            return 'pd-status-container pd-status-container-new'
        } else if (status === APP_CONSTANTS.PROJECT_STATUS.PENDING) {
            return 'pd-status-container pd-status-container-pending'
        } else if (status === APP_CONSTANTS.PROJECT_STATUS.IN_PROGRESS) {
            return 'pd-status-container pd-status-container-in-progress'
        } else if (status === APP_CONSTANTS.PROJECT_STATUS.COMPLETE) {
            return 'pd-status-container pd-status-container-complete'
        } else if (status === APP_CONSTANTS.PROJECT_STATUS.ON_HOLD) {
            return 'pd-status-container pd-status-container-hold'
        } else if (status === APP_CONSTANTS.PROJECT_STATUS.CANCELLED) {
            return 'pd-status-container pd-status-container-cancelled'
        }
    }

    const getProjectAddress = (projectData) => {
        let address = `${!isEmpty(projectData.city) ? `${projectData.city}, ` : ''}${!isEmpty(projectData.state) ? `${projectData.state}, ` : ''}${!isEmpty(projectData.country) ? `${projectData.country}, ` : ''}`
        return address
    }

    const isProjectByEmployee = (projectData) => {
        if (projectData.projectAuthorType === APP_CONSTANTS.USER_ROLE_TYPE.EMPLOYEE) {
            if (parseFloat(projectData.projectAuthorId) === parseFloat(user.data.userDetails.employeeId)) {
                return true
            } else if (projectData.assignedEmployees.includes(parseFloat(user.data.userDetails.employeeId))) {
                return true
            } else {
                return false
            }
        } else {
            return false
        }
    }

    const getAmountWithCurrency = (e, amount) => {
        return (displayCurrencySymbolLeft(e.currencyRegion) ?
            <span>
                {e.currencySymbol} {amount}
            </span>
            : <span>
                {amount} {e.currencySymbol}
            </span>
        )
    }

    const isPermissionAllowed = (type) => {
        if (type === PERMISSION_SUB_TYPE.PROJECT.UPDATE_DETAILS) {
            return checkFunctionalityPermission(user, PERMISSION_TYPE.PROJECT, PERMISSION_SUB_TYPE.PROJECT.UPDATE_DETAILS, employeeSelectedBusiness, employeeSelectedLocation)
        } else if (type === PERMISSION_SUB_TYPE.PROJECT.VIEW_COSTING) {
            return checkFunctionalityPermission(user, PERMISSION_TYPE.PROJECT, PERMISSION_SUB_TYPE.PROJECT.VIEW_COSTING, employeeSelectedBusiness, employeeSelectedLocation)
        } else if (type === PERMISSION_SUB_TYPE.PROJECT.ACCEPT_REJECT_EMPLOYEE_REQUEST) {
            return checkFunctionalityPermission(user, PERMISSION_TYPE.PROJECT, PERMISSION_SUB_TYPE.PROJECT.ACCEPT_REJECT_EMPLOYEE_REQUEST, employeeSelectedBusiness, employeeSelectedLocation)
        }

    }

    const handleRequestProjectClick = () => {
        if (isEmpty(state)) {
            displayErrorToast('Something went wrong. Please try refreshing the page')
        } else {
            setLoading(true)
            const data = {
                employeeId: user.data.userDetails.employeeId,
                userType: user.data.userDetails.userType,
                projectId: state
            }
            dispatch(requestProjectRequest(data))
        }
    }

    const handleAssignEmpProjectClick = (element) => {
        if (isEmpty(state)) {
            displayErrorToast('Something went wrong. Please try refreshing the page')
        } else {
            if (isLoggedInUserEmployee(user) && parseFloat(element.employeeId) === parseFloat(user.data.userDetails.employeeId)) {
                displayErrorToast('Cannot approve self request')
                return
            }
            setLoading(true)
            const data = {
                employeeId: element.employeeId,
                userType: element.userType,
                projectId: state
            }
            dispatch(projectAssignEmployeeRequest(data))
        }
    }

    const handleRejectEmpProjectReqClick = (element) => {
        if (isEmpty(state)) {
            displayErrorToast('Something went wrong. Please try refreshing the page')
        } else {
            if (isLoggedInUserEmployee(user) && parseFloat(element.employeeId) === parseFloat(user.data.userDetails.employeeId)) {
                displayErrorToast('Cannot decline self request')
                return
            }
            setLoading(true)
            const data = {
                employeeId: element.employeeId,
                userType: element.userType,
                projectId: state
            }
            dispatch(rejectEmployeeProjectRequest(data))
        }
    }

    const handleRemoveEmpProjectClick = (element) => {
        if (isEmpty(state)) {
            displayErrorToast('Something went wrong. Please try refreshing the page')
        } else if (!isPermissionAllowed(PERMISSION_SUB_TYPE.PROJECT.UPDATE_DETAILS)) {
            displayErrorToast('Permission not allowed to update project details')
        } else {
            if (isLoggedInUserEmployee(user) && parseFloat(element.employeeId) === parseFloat(user.data.userDetails.employeeId)) {
                displayErrorToast('Cannot remove self from project')
                return
            }
            setLoading(true)
            const data = {
                employeeId: element.employeeId,
                userType: element.userType,
                projectId: state
            }
            dispatch(projectRemoveEmployeeRequest(data))
        }
    }

    const handleUpdateClick = () => {
        if (isEmpty(state)) {
            displayErrorToast('Something went wrong. Please try refreshing the page')
        } else if (isEmpty(name)) {
            displayErrorToast('Project name cannot be blank')
        } else if (isEmpty(description)) {
            displayErrorToast('Project description cannot be blank')
        } else {
            setLoading(true)
            const fd = new FormData()
            fd.append('projectId', state.projectId)
            fd.append('name', name)
            fd.append('description', description)
            fd.append('isInvitationOpen', isNominationOpen)
            dispatch(updateProjectDetailRequest(fd))
        }

    }

    const handleUpdateStatusClick = () => {
        if (isEmpty(state)) {
            displayErrorToast('Something went wrong. Please try refreshing the page')
        } else if (isEmpty(selectedStatus)) {
            displayErrorToast('Project status not selected')
        } else {
            setLoading(true)
            const fd = new FormData()
            fd.append('projectId', state.projectId)
            fd.append('status', selectedStatus.key)
            dispatch(updateProjectDetailRequest(fd))
            setShowStatusChangeModal(false)
        }
    }

    const handleAddCommentClick = () => {
        if (isEmpty(comment)) {
            displayErrorToast('Comment cannot be blank')
        } else if (isEmpty(state)) {
            displayErrorToast('Something went wrong. Please try refreshing the page')
        } else {
            setLoading(true)
            const fd = new FormData()
            fd.append('projectId', state.projectId)
            fd.append('comment', comment)
            fd.append('sender', `${user.data.userDetails.firstName} ${user.data.userDetails.lastName}`)
            dispatch(updateProjectDetailRequest(fd))
        }
    }

    return (
        <>
            <CommonScreenContent>
                <ScreenLabel label='Project Details' />
                {!isEmpty(projectDetailSuccess) && <CommonFormBorder>
                    <div className="pd-img-parent-container">
                        <div className="pd-img-container">
                            <img src={require('../../../assets/logo_togethra.png')} className="img" />
                        </div>
                    </div>
                    <div className="pd-status-row-container">
                        <div className={getStatusClassname(projectDetailSuccess.data.projectStatus)}>{removeSpecialCharAndChangeToPascal(projectDetailSuccess.data.projectStatus)}</div>
                        {isPermissionAllowed(PERMISSION_SUB_TYPE.PROJECT.UPDATE_DETAILS) && <div className="ed-role-img-container"
                            onClick={() => { setShowStatusChangeModal(true) }}>
                            <img src={require('../../../assets/ic_edit_pen.png')} className="img" />
                        </div>}
                    </div>

                    <div className="pd-name-container">
                        <div className="pd-name-label">{name}</div>
                        {isPermissionAllowed(PERMISSION_SUB_TYPE.PROJECT.UPDATE_DETAILS) && <div className="ed-role-img-container"
                            onClick={() => { setShowNameEdit(!showNameEdit) }}>
                            <img src={require('../../../assets/ic_edit_pen.png')} className="img" />
                        </div>}
                    </div>
                    {showNameEdit && <CommonInputFloatFull
                        type='text'
                        id='name'
                        onChange={e => setName(e.target.value)}
                        placeholder='Project Name'
                        value={name}
                    />}
                    <div className="pd-description-container">
                        <div className="pd-description-label">{description}</div>
                        {isPermissionAllowed(PERMISSION_SUB_TYPE.PROJECT.UPDATE_DETAILS) && <div className="pd-description-edit-container"
                            onClick={() => { setShowDescriptionEdit(!showDescriptionEdit) }}> <div className="ed-role-img-container">
                                <img src={require('../../../assets/ic_edit_pen.png')} className="img" />
                            </div></div>}
                    </div>
                    {showDescriptionEdit && <CommonInputFloatFull
                        type='text'
                        id='description'
                        onChange={e => setDescription(e.target.value)}
                        placeholder='Project Description'
                        value={description}
                        multiline={true}
                        rows={4}
                    />}
                    {isPermissionAllowed(PERMISSION_SUB_TYPE.PROJECT.UPDATE_DETAILS) && <CommonCheckbox
                        id='invitationOpen'
                        label='Is project open for employee(s) assignment'
                        value={isNominationOpen}
                        onChange={() => {
                            setIsNominationOpen(!isNominationOpen)
                        }}
                    />}

                    <div className="pd-icon-row-container">
                        <div className="pd-icon-container">
                            <img src={require('../../../assets/ic_calendar.png')} className="img" />
                        </div>
                        <div className="pd-icon-label">{moment.utc(projectDetailSuccess.data.startDate).local().format('DD MMM YYYY')} - {moment.utc(projectDetailSuccess.data.endDate).local().format('DD MMM YYYY')}</div>
                    </div>
                    <div>
                        <div className="pd-customer-label">{projectDetailSuccess.data.customerType === APP_CONSTANTS.CUSTOMER_TYPE.RESIDENTIAL ? projectDetailSuccess.data.customerName : projectDetailSuccess.data.customerBusinessName}</div>
                        <FormFieldLabel label='Contact Person Details' />
                        <div className="pd-icon-row-container">
                            <div className="pd-icon-container">
                                <img src={require('../../../assets/ic_user.png')} className="img" />
                            </div>
                            <div className="pd-icon-label">{projectDetailSuccess.data.contactPersonName}</div>
                        </div>
                        {!isEmpty(projectDetailSuccess.data.contactPersonNumber) && <div className="pd-icon-row-container">
                            <div className="pd-icon-container">
                                <img src={require('../../../assets/ic_phone.png')} className="img" />
                            </div>
                            <div className="pd-icon-label">{projectDetailSuccess.data.contactPersonNumber}</div>
                        </div>}
                        {!isEmpty(projectDetailSuccess.data.contactPersonEmail) && <div className="pd-icon-row-container">
                            <div className="pd-icon-container">
                                <img src={require('../../../assets/ic_email.png')} className="img" />
                            </div>
                            <div className="pd-icon-label">{projectDetailSuccess.data.contactPersonEmail}</div>
                        </div>}
                        <FormFieldLabel label='Project Address' />
                        {!isEmpty(projectDetailSuccess.data.address) && <div className="pd-address">{projectDetailSuccess.data.address}</div>}
                        {!isEmpty(getProjectAddress(projectDetailSuccess.data)) && <div className="pd-address">{getProjectAddress(projectDetailSuccess.data)}</div>}
                        {!isEmpty(projectDetailSuccess.data.addressLink) && <div className="pd-address">{projectDetailSuccess.data.addressLink}</div>}
                        {(isLoggedInUserBusiness(user) || isProjectByEmployee(projectDetailSuccess.data) ||
                            isPermissionAllowed(PERMISSION_SUB_TYPE.PROJECT.VIEW_COSTING)) && <div>
                                <FormFieldLabel label='Project Costing Details' />
                                {projectDetailSuccess.data.isEstimatedAmount && <div className="pd-estimate-label">* Estimated Amount</div>}
                                <div className="pd-cost-row-container">
                                    <div className="pd-row-item-key-container">Total</div>
                                    <div className="pd-row-item-key-container">{getAmountWithCurrency(projectDetailSuccess.data, projectDetailSuccess.data.amountBeforTax)}</div>
                                </div>
                                {!isEmpty(projectDetailSuccess.data.taxInformation) && <div>
                                    <FormFieldLabel label='Tax Information' />
                                    {projectDetailSuccess.data.taxInformation.map(e => (<div className="pd-cost-row-container">
                                        <div className="pd-row-item-key-container">{e.taxType}</div>
                                        <div className="pd-row-item-key-container">{e.taxPercent}%</div>
                                    </div>))}
                                </div>}
                                <FormFieldLabel label='Final Payable Amount' />
                                <div className="pd-cost-row-container">
                                    <div className="pd-row-item-key-container text-color-blue">Grand Total</div>
                                    <div className="pd-row-item-key-container text-color-blue">{getAmountWithCurrency(projectDetailSuccess.data, projectDetailSuccess.data.finalAmount)}</div>
                                </div>
                            </div>}
                        <FormFieldLabel label='Assigned Employees Details' />
                        {!isEmpty(projectDetailSuccess.data.assignedEmployeesDetail) && <div className="pd-emp-row-container">
                            {projectDetailSuccess.data.assignedEmployeesDetail.map(item => (<div className="pd-emp-row-item-container">
                                <div className="pd-eri-name">{item.firstName} {item.lastName}</div>
                                <div className="pd-eri-code">{item.userType === APP_CONSTANTS.USER_ROLE_TYPE.EMPLOYEE ? `${item.employeeBusinessMapping[0].employeeCode}` : `${removeSpecialCharAndChangeToPascal(item.userType)}`}</div>
                                <div className="pd-eri-btn-container">
                                    <div className="pd-eri-btn-red" onClick={() => { handleRemoveEmpProjectClick(item) }}>Remove</div>
                                </div>
                            </div>))}
                        </div>}
                        {isEmpty(projectDetailSuccess.data.assignedEmployeesDetail) && <div className="content-error">No employee assigned on project</div>}
                        {isPermissionAllowed(PERMISSION_SUB_TYPE.PROJECT.ACCEPT_REJECT_EMPLOYEE_REQUEST) && <div>
                            <FormFieldLabel label='Employee Request for Assignment' />
                            {!isEmpty(projectDetailSuccess.data.employeesRequestDetail) && <div className="pd-emp-row-container">
                                {projectDetailSuccess.data.employeesRequestDetail.map(item => (<div className="pd-emp-row-item-container">
                                    <div className="pd-eri-name">{item.firstName} {item.lastName}</div>
                                    <div className="pd-eri-code">{item.userType === APP_CONSTANTS.USER_ROLE_TYPE.EMPLOYEE ? `${item.employeeBusinessMapping[0].employeeCode}` : `${removeSpecialCharAndChangeToPascal(item.userType)}`}</div>
                                    <div className="pd-eri-btn-container">
                                        <div className="pd-eri-btn-red" onClick={() => { handleRejectEmpProjectReqClick(item) }}>Decline</div>
                                        <div className="pd-eri-btn-green" onClick={() => { handleAssignEmpProjectClick(item) }}>Approve</div>
                                    </div>
                                </div>))}
                            </div>}
                            {isEmpty(projectDetailSuccess.data.employeesRequestDetail) && <div className="content-error">No employee assignment request</div>}
                        </div>}
                        {!isEmpty(projectDetailSuccess.data.documentList) && <div>
                            <FormFieldLabel label='Project Documents' />
                            <div className="pd-img-row-container">
                                {projectDetailSuccess.data.documentList.map(e => (<div className="pd-img-row-item-container">
                                    <img src={`${config.imageUrl}${e}`} className="img" />
                                </div>))}
                            </div>
                        </div>}
                        <FormFieldLabel label='Comments' />
                        {isEmpty(projectDetailSuccess.data.comments) && <div className="content-error">No Comments Found!</div>}
                        {!isEmpty(projectDetailSuccess.data.comments) && <div className="td-comment-col-container">
                            {projectDetailSuccess.data.comments.map(item => (<div className="td-comment-item-container">
                                <div className="td-comment-date">{moment.utc(item.date).local().format('DD/MM/YYYY')}</div>
                                <div className="td-comment">{item.message}</div>
                                <div className="td-comment-name">{item.sender}</div>
                            </div>))}
                        </div>}
                        <CommonInputFloatFull
                            type='text'
                            id='comments'
                            onChange={e => setComment(e.target.value)}
                            placeholder='Enter new comment'
                            value={comment}
                            rows={2}
                            multiline={true} />
                        <div className="td-comment-btn-container">
                            <CommonButton
                                label='Submit Comment'
                                isInverted={true}
                                onClick={() => { handleAddCommentClick() }} />
                        </div>
                        <ButtonRow isVertical={true}>
                            {projectDetailSuccess.data.isInvitationOpen === true && isLoggedInUserEmployee(user) &&
                                <CommonButton
                                    label='Request'
                                    onClick={() => { handleRequestProjectClick() }}
                                />}
                            {isPermissionAllowed(PERMISSION_SUB_TYPE.PROJECT.UPDATE_DETAILS) &&
                                <CommonButton
                                    label='Update Details'
                                    onClick={() => { handleUpdateClick() }}
                                />}
                        </ButtonRow>
                    </div>
                </CommonFormBorder>}
                {!isEmpty(projectDetailError) && <div className="content-error">{projectDetailError.message}</div>}
            </CommonScreenContent>
            <Modal
                onHide={() => { setShowStatusChangeModal(false) }}
                show={showStatusChangeModal}
                size="lg"
                aria-labelledby="contained-modal-title-vcenter"
                centered
            >
                <Modal.Header closeButton>
                    Update Project Status
                </Modal.Header>
                <Modal.Body>
                    <FormFieldLabel label='Select Project Status' />
                    <Select
                        className='select-full-width-no-border'
                        value={selectedStatus}
                        getOptionLabel={e => e.value}
                        getOptionValue={e => e}
                        options={STATUS_LIST}
                        placeholder='Select Status'
                        onChange={e => setSelectedStatus(e)} />
                    <ButtonRow>
                        <CommonButton label='Update'
                            onClick={() => {
                                handleUpdateStatusClick()
                            }}
                        />
                    </ButtonRow>
                </Modal.Body>
            </Modal>
            <ToastContainer />
            <Loader active={isLoading} text='Please wait...' />
        </>
    )
}

export default ProjectDetail